import { render, staticRenderFns } from "./List-Shipping-Rates.vue?vue&type=template&id=488667b2&scoped=true"
import script from "./List-Shipping-Rates.vue?vue&type=script&lang=js"
export * from "./List-Shipping-Rates.vue?vue&type=script&lang=js"
import style0 from "./List-Shipping-Rates.vue?vue&type=style&index=0&id=488667b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488667b2",
  null
  
)

export default component.exports